<template>
	<div class="bg">
		<el-card class="content">
			<div class="content_cover"></div>
			<el-row>
				<div class="top" @click="close">✖</div>
			</el-row>
			<el-row type="flex" justify="center">
				<img src="../../assets/img/tips(２).png" alt="">
			</el-row>
			<el-row type="flex" justify="center" style="margin:20px 0 50px 0">
				<span class="tips">场所信息审批中，请稍后</span>
			</el-row>
			<el-divider></el-divider>
			<el-row type="flex" justify="center">
				<el-button class="go_out_btn" @click="close">退出系统</el-button>
				<!-- <el-button type="primary" class="revise_btn">修改</el-button> -->
			</el-row>
		</el-card>
	</div>
</template>

<script>
export default {
	name: 'ApprovalIngVue',
	methods: {
		close() {
			this.$router.push('/login')
		}
	}
}
</script>

<style lang="less" scoped>
.bg {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background: url('../../assets/img/login_bg.png')
}

.content {
	position: relative;
	width: 640px;
	height: 405px;
	border-radius: 10px;

	/deep/ .el-card__body {
		padding: 0;
	}
}



.content_cover {
	position: absolute;
	top: 0;
	left: 0;
	width: 640px;
	height: 145px;
	background: linear-gradient(0deg, rgba(255, 183, 45, 0) 0%, rgba(255, 183, 45, 0.2) 100%);
	border-radius: 10px;
}

.top {
	float: right;
	margin: 20px 23px 33px 0;
	width: 30px;
	height: 30px;
	border: 1px solid #787F82;
	border-radius: 50%;
	color: #787F82;
	text-align: center;
	line-height: 30px;
	// cursor
}

/deep/ .top:hover {
	cursor: pointer;
}

.tips {
	font-size: 18px;
	font-family: Source Han Sans SC;
	font-weight: bold;
	color: #5D5951;
}

.go_out_btn {
	width: 214px;
	height: 50px;
	background: #FFFFFF;
	border: 1px solid #ACA9B4;
	border-radius: 6px;
}

.revise_btn {
	width: 214px;
	height: 50px;
	background: #6345D5;
	border-radius: 6px;
}
</style>